import {
    VALIDATE_STUDENT_REQUEST,
    VALIDATE_STUDENT_SUCCESS,
    VALIDATE_STUDENT_FAILURE,
    CREATE_STUDENT_REQUEST,
    CREATE_STUDENT_SUCCESS,
    CREATE_STUDENT_FAILURE
} from "../constants/actionTypes";
const initialState = {
};
export default function StudentReducer(state = initialState, action = {}) {
    const { type, response } = action;
    switch (type) {
        case VALIDATE_STUDENT_REQUEST:
          return {
            ...state,
            loading: true,
          };
        case VALIDATE_STUDENT_SUCCESS: {
          const data = JSON.parse(response.data);
          let student = (data && Object.keys(data).length === 0 && data.constructor === Object) ? JSON.parse(response.data) : JSON.parse(response.data)[0];
          if(!student) student = {...JSON.parse(response.data)}
          student = !student ? {...JSON.parse(response.data)} : student
          return {
            ...state,
            student: student,
            loading: false,
          };
        }
        case VALIDATE_STUDENT_FAILURE:
          return {
            ...state,
            loading: false,
          };
        
        case CREATE_STUDENT_REQUEST:
          return {
            ...state,
            loading: true,
          };
        case CREATE_STUDENT_SUCCESS: {
          return {
            ...state,
            student: JSON.parse(response.data)[0],
            loading: false,
          };
        }
        case CREATE_STUDENT_FAILURE:
          return {
            ...state,
            languageSaved: false,
            loading: false,
          };
        default:
        return state;
    }
}